import { useTranslation } from '../../core/hooks/use-translation';

/**
 * The dark banner over the documents.
 *
 * **The emphasised word is three keys, not one string of HTML.** The live page stores
 * `"Заңдық <em>ақпарат</em> беті"` in its translation table, where a translator who loses a tag
 * loses the gradient — and a translator who adds one gets it rendered. Here the markup is markup
 * and only the three words are translated, so the shape of the title is the same in both languages
 * by construction.
 */
export function PolicyHero() {
    const { t } = useTranslation();

    return (
        <section className="legal-hero">
            <div className="legal-hero-grid" aria-hidden="true" />
            <div className="legal-hero-inner">
                <p className="legal-hero-badge">
                    <span className="legal-hero-badge-dot" aria-hidden="true" />
                    <span>{t('policy.hero.badge')}</span>
                </p>
                <h1 className="legal-hero-title">
                    {t('policy.hero.title_before')} <em>{t('policy.hero.title_emphasis')}</em>{' '}
                    {t('policy.hero.title_after')}
                </h1>
                <p className="legal-hero-sub">{t('policy.hero.sub')}</p>
            </div>
        </section>
    );
}
